var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1697 10.183C16.5268 10.5429 16.5268 11.1234 16.1697 11.4833L11.5903 16.0984C11.2312 16.4603 10.6468 16.4626 10.2849 16.1035C9.92305 15.7445 9.92078 15.16 10.2798 14.7982L14.2141 10.8331L10.2798 6.8681C9.92078 6.50623 9.92305 5.9218 10.2849 5.56274C10.6468 5.20368 11.2312 5.20595 11.5903 5.56782L16.1697 10.183Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7988 10.8347C15.7988 11.3444 15.3856 11.7577 14.8758 11.7577L5.58949 11.7577C5.07971 11.7577 4.66645 11.3444 4.66645 10.8347C4.66645 10.3249 5.07971 9.91162 5.58949 9.91162L14.8758 9.91162C15.3856 9.91162 15.7988 10.3249 15.7988 10.8347Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.8ee73c6515f8f7ddd2db4adeef3aa7cd.svg";
export { ForwardRef as ReactComponent };